module.exports = __webpack_public_path__ + "img/icon_copy.f2bdbcfd.svg";